<template
  v-loading="loading"
  element-loading-text="正在导出中"
  element-loading-spinner="el-icon-loading"
  element-loading-background="rgba(0, 0, 0, 0.8)"
>
  <div class="app-container">
    <!--查询组-->
    <div class="filter-container" style="width:100%">
      <el-select v-if="current_user.is_system == 1" v-model="listQuery.card_type" class="filter-item" clearable filterable placeholder="会员卡类型" @change="changeMerchants">
        <el-option v-for="item in merchants" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <div class="block" style="display: inline-block;margin-bottom: 10px;vertical-align: middle;">
        <el-date-picker
          v-model="listQuery.search_time"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
      <el-button class="filter-item" type="success" icon="el-icon-download" @click="OutData">导出</el-button>
    </div>
    <!--动作组-->
    <!--动作组-->
    <div class="action-container">
      <span style="margin-right:10px;">总订单量<span style="color:red;font-size:18px;"> {{ total_result.order_num ? total_result.order_num : 0 }}</span> 单</span>
      <span style="margin-right:10px;">总计金额<span style="color:red;font-size:18px;"> {{ total_result.total_money ? total_result.total_money : 0 }}</span> 元</span>
      <span style="margin-right:10px;">优惠金额<span style="color:red;font-size:18px;"> {{ total_result.discount_money ? total_result.discount_money : 0 }}</span> 元</span>
    </div>
    <!--表开始-->
    <el-table
      ref="singleTable"
      v-loading="listLoading"
      :data="list"

      fit
      border
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
      @selection-change="handleSelectionChange"
    >
      <!--  show-summary
      :summary-method="totalOutPrice" -->
      <el-table-column label="序号" align="center" width="50" type="index"></el-table-column>
      <el-table-column label="会员卡名称" align="center" show-overflow-tooltip prop="card_name"></el-table-column>
      <el-table-column label="支付金额" align="center" prop="total_price"></el-table-column>
      <el-table-column align="center" prop="pay_time" label="支付时间"></el-table-column>
      <el-table-column align="center" prop="nickname" label="下单用户"></el-table-column>
      <el-table-column align="center" prop="status" label="订单状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0 || scope.row.status === 1" size="danger" type="info">待支付</el-tag>
          <el-tag v-if="scope.row.status === 2" size="small" type="success">待核销</el-tag>
          <el-tag v-if="scope.row.status === 3" size="small" type="danger">已完成</el-tag>
          <el-tag v-if="scope.row.status === 4" size="small" type="success">退款中</el-tag>
          <el-tag v-if="scope.row.status === 5" size="small" type="danger">已退款</el-tag>
          <el-tag v-if="scope.row.status === 6" size="small" type="success">已取消</el-tag>
        </template></el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
  </div>
</template>

<script>
import api from '@/api/finance' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import { mapGetters } from 'vuex'
import card from '@/api/card'
export default {
  name: 'FinanceMember',
  components: { Pagination },
  // 列绑定格式化器
  filters: {
  },
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      fromstatus: false,
      checkid: [],
      loading: false,
      // 额外过滤条件
      listQuery: {
        card_type: '',
        search_time: [],
        type: 3
      },
      total_result: {},
      discount_money: 0,
      merchants: [], // 门店列表
      merchants_id: '' // 门店id
    }
  },
  computed: {
    ...mapGetters(['current_user'])
  },
  created() {
    var now = new Date()
    this.listQuery.year = String(now.getFullYear())// 得到当前年份
    this.loadData() // 页面加载创建时加载数据
    this.getMerchants() // 获取商户信息
    if (this.current_user.is_system !== 1) {
      this.merchants_id = this.current_user.id
    }
  },
  methods: {
    getMerchants() {
      card.TypeList({}).then(res => {
        this.merchants = res.data
      })
    },
    // 门店选择改变
    changeMerchants(newVal) {
      if (newVal != null && newVal !== '') {
        if (this.listQuery.operate_type != null) {
          this.listQuery.operate_type = ''
        }
        if (this.listQuery.reserve_type != null) {
          this.listQuery.reserve_type = ''
        }
        this.merchants_id = newVal
        this.getdictionary() // 分类
      } else {
        this.merchants_id = ''
        this.listQuery.operate_type = ''
        this.listQuery.reserve_type = ''
      }
    },
    // 加载数据表
    loadData() {
      // 请求前处理
      this.loadListBefore(this.QueryParams)
      if (this.listQuery.search_time == null || this.listQuery.search_time === '') {
        this.listQuery.search_time = []
      }
      this.api.QueryPlatform(this.listQuery).then(response => {
        console.log(response)
        this.listLoading = false
        this.list = response.data.items
        this.total = response.data.total
        this.total_result = response.data.total_result
      })
    },
    // 置空提交数据
    resetTemp() {
      this.temp = {
        id: undefined,
        name: '',
        order_num: 99999
      }
    },
    totalOutPrice(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        // 订单量
        if (column.property === 'order_nums') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr.toFixed(2))
            if (!isNaN(value)) {
              return Number((Number(prev.toFixed(2)) + Number(curr.toFixed(2))).toFixed(2))
            } else {
              return Number(prev)
            }
          }, 0)
          sums[index] += ' 单'
        }

        // 订单总金额
        if (column.property === 'total_amount') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr.toFixed(2))
            if (!isNaN(value)) {
              return Number(
                (Number(prev.toFixed(2)) + Number(curr.toFixed(2))).toFixed(2)
              )
            } else {
              return Number(prev)
            }
          }, 0)
          sums[index] += '元'
        }
        // 支付金额
        if (column.property === 'total_price') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr.toFixed(2))
            if (!isNaN(value)) {
              return Number((Number(prev.toFixed(2)) + Number(curr.toFixed(2))).toFixed(2))
            } else {
              return Number(prev)
            }
          }, 0)
          sums[index] += ' 元'
        }

        // 折扣金额
        if (column.property === 'discount_money') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr.toFixed(2))
            if (!isNaN(value)) {
              return Number(
                (Number(prev.toFixed(2)) + Number(curr.toFixed(2))).toFixed(2)
              )
            } else {
              return Number(prev)
            }
          }, 0)
          sums[index] += '元'
        }
      })
      return []
    },
    // 获取多选的数据
    handleSelectionChange(val) {
      this.multipleSelection = val// 存储选中的数据
    },
    // 批量导出
    OutData() {
      this.loading = true
      api.ExportPlatformList(this.listQuery).then(res => {
        this.loading = false
        window.open(res.data)
        this.$notify({ title: '成功', message: '财务统计数据导出成功', type: 'success', duration: 2000 })
      })
    }
  }
}
</script>
